// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2U88V","cell":"ColumnAccessor_cell__T24Yf","firstCellAccent":"ColumnAccessor_firstCellAccent__2f43y"};